/** Справочник переменных и полей печати чеков (из docs/printFields.js) */
export const printFieldCategories = [
  {
    title: "Переменные шаблонов {{…}} (слип / нефискальные)",
    fields: {
      companyName: {
        type: "string",
        description:
          "Название компании: companyName из контекста, иначе station.basename / station.name",
      },
      dateTime: {
        type: "string",
        description: "Дата и время печати в формате ДД.ММ.ГГГГ чч:мм:сс (момент печати)",
      },
      orderId: { type: "string", description: "Номер чека — String(checkid)" },
      clientName: { type: "string", description: "Название/клиент чека — check.name" },
      total: {
        type: "string",
        description:
          "Сумма: сначала paymentTotal, иначе checkTotal; формат 0.00 с пробелами-разделителями",
      },
      paymentMethod: { type: "string", description: "Название способа оплаты — payment.name" },
      transactionId: {
        type: "string",
        description:
          "Идентификатор операции: referencenumber → иначе authcode → иначе slipnumber",
      },
      terminalId: { type: "string", description: "ID терминала — checkpayment.terminalid" },
      slipText: {
        type: "string",
        description: "Полный текст слипа с терминала — checkpayment.sliptext",
      },
      rawText: {
        type: "string",
        description: "Синоним slipText для шаблонов нефискальной копии слипа",
      },
      authCode: { type: "string", description: "Код авторизации — checkpayment.authcode" },
      cardNumber: {
        type: "string",
        description: "Маскированный номер карты — checkpayment.cardnumber",
      },
      referenceNumber: { type: "string", description: "RRN — checkpayment.referencenumber" },
      slipNumber: { type: "string", description: "Номер слипа — checkpayment.slipnumber" },
      transDate: { type: "string", description: "Дата операции терминала — checkpayment.transdate" },
      transTime: { type: "string", description: "Время операции терминала — checkpayment.transtime" },
      responseCode: {
        type: "string",
        description: "Код ответа терминала — checkpayment.responsecode",
      },
      msgNumber: { type: "string", description: "Номер сообщения — checkpayment.msgnumber" },
    },
  },
  {
    title: "Нефискальная копия (группа other)",
    fields: {
      checkTotalFormatted: {
        type: "string",
        description: "Итог чека (slipContext.checkTotal) в формате денег 0.00",
      },
      fiscalReceiptNumber: {
        type: "string",
        description: "Номер чека ATOL после фискализации; иначе пустая строка",
      },
      fiscalDocumentNumber: {
        type: "string",
        description: "Номер фискального документа (ФД) ATOL; иначе пустая строка",
      },
      fiscalSign: {
        type: "string",
        description: "Фискальный признак (ФП) ATOL; иначе пустая строка",
      },
      items: {
        type: "Array<{ line: string }>",
        description:
          'Позиции для {{#items}}{{line}}{{/items}}: "{name}  {qty} x {unitPrice} = {total}[  НДС {ndsTotal}]"',
      },
      payments: {
        type: "Array<{ line: string }>",
        description:
          'Оплаты для {{#payments}}{{line}}{{/payments}}: "{paymentName}: {totalSum}"',
      },
    },
  },
  {
    title: "Накладная (invoice)",
    fields: {
      invoiceItems: {
        type: "Array<{ line: string }>",
        description:
          'Позиции накладной: "{name}  {amount} x {price} = {total}" из checkitems',
      },
    },
  },
  {
    title: "Фискальный чек ATOL — документ",
    fields: {
      fiscalReceiptKind: {
        type: "'sell' | 'sell_return'",
        description: "Тип документа: приход или возврат прихода",
      },
      "operator.name": {
        type: "string",
        description: "Кассир (FFD 1021): user.fiscalname → user.name → «Кассир»",
      },
      "operator.inn": {
        type: "string",
        description: "ИНН кассира (FFD 1203): user.inn, ровно 12 цифр",
      },
      taxationType: {
        type: "string",
        description: "СНО: settings.nalog → nalog.atolvalue (напр. osn)",
      },
      checkTotal: {
        type: "number",
        description: "Итог чека: сумма позиций после бонусной доли",
      },
      department: { type: "number", description: "Отдел позиции на ККТ; всегда 1" },
      positionPaymentMethod: {
        type: "'fullPayment' | 'advance'",
        description: "FFD 1214: fullPayment на продаже, advance на авансе",
      },
      positionPaymentObject: {
        type: "'commodity' | 'payment'",
        description: "FFD 1212: commodity на продаже, payment на авансе",
      },
    },
  },
  {
    title: "Фискальный чек ATOL — позиции",
    fields: {
      lineName: { type: "string", description: "Наименование позиции — item.name" },
      lineAmount: { type: "number", description: "Количество — checkitem.amount" },
      lineFiscalPrice: {
        type: "number",
        description: "Цена за единицу для ККТ: total/amount, после бонусной доли",
      },
      lineTotal: { type: "number", description: "Сумма позиции — checkitem.total" },
      lineNds: {
        type: "string",
        description: "Тип НДС ATOL (nds.atolvalue)",
      },
      lineNdsTotal: { type: "number | null", description: "Сумма НДС — checkitem.ndstotal" },
      lineIsBouquet: {
        type: "boolean",
        description: "Флаг букета из checkitem.bouquet",
      },
      komplektcheckitemid: {
        type: "number",
        description: "Фильтр: в печать только позиции с komplektcheckitemid = 0",
      },
    },
  },
  {
    title: "Фискальный чек ATOL — оплаты",
    fields: {
      paymentid: {
        type: "number",
        description: "Ключ группы: -2 сертификат → prepaid; -98 предоплата → prepaid",
      },
      paymentName: { type: "string", description: "Имя оплаты для нефискального списка" },
      paymentTotalSum: {
        type: "number",
        description: "Сумма группы, регистрируемая как платёж на ККТ",
      },
      paymentFiscal: {
        type: "number | null",
        description: "Маппинг типа ATOL: 0→cash, 1→electronically, иначе other",
      },
    },
  },
  {
    title: "Аванс / предзаказ",
    fields: {
      receiptTitle: {
        type: "string",
        description: 'Единственная позиция аванса: «Аванс по заказу номер {orderid}»',
      },
      advanceAmountTotal: {
        type: "number",
        description: "Сумма аванса: price=qty=1=position sum=receipt total",
      },
    },
  },
  {
    title: "После фискализации",
    fields: {
      receiptNumber: { type: "number", description: "Номер чека ATOL → {{fiscalReceiptNumber}}" },
      documentNumber: { type: "number", description: "Номер ФД ATOL → {{fiscalDocumentNumber}}" },
      fiscalSignOut: { type: "string", description: "ФП ATOL → {{fiscalSign}}" },
    },
  },
  {
    title: "Шаблоны и оборудование (настройки станции)",
    fields: {
      "printtemplate.printtemplateid": {
        type: "number",
        description: "PK шаблона; выбор через default*Id или первый в списке станции",
      },
      "printtemplate.name": { type: "string", description: "Отображаемое имя шаблона" },
      "printtemplate.value": {
        type: "string | null",
        description: "Тело шаблона с {{var}} и {{#array}}…{{/array}}",
      },
      "printtemplate.slipdefault": { type: "number", description: "≠0 → группа slip (эквайринг)" },
      "printtemplate.nakladnayadefault": {
        type: "number",
        description: "≠0 → группа invoice (накладная)",
      },
      "printtemplate.otherdefault": {
        type: "number",
        description: "≠0 (или без флагов) → группа other (нефискальная копия)",
      },
      defaultPrintTemplateSlipId: {
        type: "number | null",
        description: "Предпочитаемый шаблон слипа",
      },
      defaultPrintTemplateNonfiscalId: {
        type: "number | null",
        description: "Предпочитаемый нефискальный шаблон",
      },
      defaultPrintTemplateInvoiceId: {
        type: "number | null",
        description: "Предпочитаемый шаблон накладной",
      },
      onlineCashRegisterEnabled: { type: "boolean", description: "Гейт фискальной печати" },
      onlineCashRegisterIp: { type: "string", description: "TCP IP ATOL" },
      onlineCashRegisterPort: { type: "string", description: "TCP порт ATOL" },
      onlineCashRegisterType: { type: "string", description: "Тип ККТ, напр. atol_27f" },
      bankTerminalEnabled: {
        type: "boolean",
        description: "Запускать эквайринг до слипа/фискала",
      },
      bankTerminalPaymentIds: {
        type: "number[]",
        description: "paymentid, идущие через терминал",
      },
      bankTerminalEcr: {
        type: "string",
        description: "Пишется в checkpayment.terminalid после операции",
      },
    },
  },
  {
    title: "Источники из БД",
    fields: {
      "check.checkid": { type: "number", description: "ID чека → orderId" },
      "check.name": { type: "string", description: "Клиент/название → clientName" },
      "check.total": { type: "number", description: "Итог чека (минус бонусы)" },
      "check.operationid": { type: "number", description: "2 = возврат → sell_return" },
      "check.storesid": { type: "number", description: "Join settings → nalog, ndsid" },
      "check.stationid": { type: "number", description: "Станция / доступные шаблоны" },
      "check.printed": { type: "number", description: "Флаг «напечатан»" },
      "checkpayment.authcode": { type: "string", description: "→ authCode / transactionId" },
      "checkpayment.slipnumber": { type: "string", description: "→ slipNumber / transactionId" },
      "checkpayment.transdate": { type: "string", description: "→ transDate" },
      "checkpayment.transtime": { type: "string", description: "→ transTime" },
      "checkpayment.msgnumber": { type: "string", description: "→ msgNumber" },
      "checkpayment.terminalid": { type: "string", description: "→ terminalId" },
      "checkpayment.referencenumber": {
        type: "string",
        description: "→ referenceNumber / transactionId",
      },
      "checkpayment.responsecode": { type: "string", description: "→ responseCode" },
      "checkpayment.cardnumber": { type: "string", description: "→ cardNumber" },
      "checkpayment.sliptext": { type: "string", description: "→ slipText / rawText" },
      "payment.name": { type: "string", description: "→ paymentMethod / лейбл группы" },
      "payment.fiscal": {
        type: "number",
        description: "0 cash, 1 card/electronically, -1/-2 нефискальный шаблон",
      },
      "nds.atolvalue": { type: "string", description: "Тип налога ATOL" },
      "nalog.atolvalue": { type: "string", description: "Система налогообложения для ATOL" },
      "settings.nalog": { type: "number", description: "FK → nalog.nalogid" },
      "settings.ndsid": { type: "number", description: "НДС по умолчанию" },
      "user.fiscalname": { type: "string", description: "Предпочтительное имя кассира" },
      "user.name": { type: "string", description: "Fallback имени кассира" },
      "user.inn": { type: "string", description: "ИНН кассира" },
      "station.name": { type: "string", description: "Fallback companyName" },
      "station.basename": { type: "string", description: "Fallback companyName" },
    },
  },
  {
    title: "Константы",
    fields: {
      BONUSES_PAYMENT_ID: {
        type: "number",
        description: "6 — исключается из платежей ККТ, уменьшает суммы позиций",
      },
      KKT_AGGREGATE_ORDER_PREPAY_PAYMENT_ID: {
        type: "number",
        description: "-98 — сумма прошлых предоплат предзаказа как один prepaid",
      },
      CERTIFICATE_PAYMENT_ID: {
        type: "number",
        description: "-2 — сертификат → prepaid на ККТ",
      },
      emptyPlaceholder: {
        type: "string",
        description: "«—» для отсутствующих {{var}} в шаблоне",
      },
    },
  },
];
